var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-group" }, [
    _c("div", { staticClass: "captcha" }, [
      _vm.imageUrl
        ? _c("img", {
            staticClass: "u-mb-sm",
            attrs: { src: _vm.imageUrl, alt: "" }
          })
        : _vm._e(),
      _c("br"),
      _vm._v(" "),
      _vm.audioUrl
        ? _c(
            "a",
            {
              staticClass: "btn btn--sm",
              attrs: { href: _vm.audioUrl },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.playAudioCaptcha.apply(null, arguments)
                }
              }
            },
            [
              _c("span", { staticClass: "icon icon--xl icon-audio--white" }),
              _vm._v(" "),
              _c("span", { staticClass: "u-vh" }, [
                _vm._v(
                  _vm._s(
                    _vm.gettext(
                      "Audio captcha: please listen and type the letters you hear"
                    )
                  )
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("audio", { ref: "audioEl" }, [
        _vm.audioUrl
          ? _c("source", {
              ref: "audioElSrc",
              attrs: { src: _vm.audioUrl, type: "audio/wav" }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.audioUrl
          ? _c("p", [
              _c("a", { attrs: { href: _vm.audioUrl } }, [
                _vm._v(_vm._s(_vm.gettext("Download audio captcha")))
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn--sm",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.refresh.apply(null, arguments)
            }
          }
        },
        [_vm._v("\n      " + _vm._s(_vm.gettext("Refresh")) + "\n    ")]
      )
    ]),
    _vm._v(" "),
    _c("label", { attrs: { for: "captcha" } }, [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm.gettext("Enter the letters and numbers you see in the image")
          ) +
          "\n  "
      )
    ]),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.response,
          expression: "response"
        }
      ],
      staticClass: "input--short",
      attrs: {
        id: "captcha",
        autocomplete: "off",
        type: "text",
        "aria-describedby": _vm.captchaDescId
      },
      domProps: { value: _vm.response },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.response = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    _c("input", {
      attrs: { type: "hidden" },
      domProps: { value: _vm.captchaKey }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d6d78cbc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6d78cbc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/Captcha.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-d6d78cbc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/Captcha.vue
// module chunks = 0